<app-loader></app-loader>
<div class="example-container" [class.example-is-mobile]="mobileQuery.matches">
    <mat-sidenav-container class="example-sidenav-container">
        <mat-sidenav
            #sidenav
            [mode]="mobileQuery.matches ? 'over' : 'side'"
            [opened]="!mobileQuery.matches"
            [fixedInViewport]="mobileQuery.matches"
        >
            <app-sidebar-user-area></app-sidebar-user-area>
            <app-navbar></app-navbar>
        </mat-sidenav>

        <mat-sidenav-content>
            <app-toolbar (toggleMenu)="toggleSidenav()"></app-toolbar>

            <main>
                <app-page-header [pageTitle]="pageTitle"></app-page-header>
                <router-outlet></router-outlet>
            </main>
        </mat-sidenav-content>
    </mat-sidenav-container>
</div>
